import { useLayoutEffect } from "react";
import { Country } from "@lookiero/sty-psp-locale";
import { Segment } from "@lookiero/sty-psp-segment";
import { TrackingEventCategory, useEmitUserEvent } from "@lookiero/sty-psp-tracking";
import { Tradename } from "@lookiero/sty-sp-tradename";
import { Order } from "../../../domain/entities/order/Order";
import { Experiments } from "../../../domain/repositories/ABTestClient";
import { financial } from "../shared/util/financial/financial";
import { experimentNameShortener } from "./experimentNameShortener";
import { PROJECT, BasketDisplayedTrackingEvent, TrackingEventName, Constants } from "./tracking";

interface UseTrackBasketDisplayedFunctionArgs {
  readonly country: Country;
  readonly segment: Segment;
  readonly userId: string;
  readonly experiments?: Experiments | undefined;
  readonly order: Order;
  readonly tradename: Tradename;
}

interface UseTrackBasketDisplayedFunction {
  (args: UseTrackBasketDisplayedFunctionArgs): void;
}

const useTrackBasketDisplayed: UseTrackBasketDisplayedFunction = ({
  country,
  segment,
  tradename,
  userId,
  experiments,
  order,
}) => {
  const emitUserEvent = useEmitUserEvent<BasketDisplayedTrackingEvent>();

  useLayoutEffect(() => {
    emitUserEvent({
      event: TrackingEventName.BASKET_DISPLAYED,
      eventCategory: TrackingEventCategory.LOOK_IN,
      section: PROJECT,
      store: country,
      segment,
      tradename,
      userId,
      userUuid: userId,
      ecommerce: {
        products: order.items.map((item) => ({
          name: item.title,
          id: item.variantId,
          price: financial(item.price.amount),
          brand: item.brand,
          category: Constants.NOT_SET,
          variant: item.size,
          list: Constants.COMPLETE_YOUR_LOOK_LIST,
          quantity: Constants.QUANTITY,
        })),
      },
      experiments: experiments ? JSON.stringify(experimentNameShortener(experiments)) : undefined,
    });
  }, [country, emitUserEvent, experiments, order.items, segment, tradename, userId]);
};

export { useTrackBasketDisplayed };
